import React from 'react'
import injectSheet from 'react-jss'
import styles from './intro.styles'
import ContextMenu from './context-menu/context-menu.container'
import AgeGroup from 'pobble-components/dist/age-group'
import Tooltip from 'pobble-components/dist/tooltip'
import { SubsCrown } from 'pobble-components/dist/subscriptions'

const Intro = ({
  classes,
  pending,
  id,
  title,
  context,
  createdBy,
  createAt,
  contributions,
  concluded,
  conclusionAuthor,
  conclusionContent,
  example,
  trainingMaterial,
  benchmarked,
  benchmarkedBy,
  canUpdate,
  isClosed,
  canClose,
  onClose,
  onReopen,
  onOpenEditTitleDialog,
  canMarkAsExample,
  onMarkAsExample,
  onUnmarkAsExample,
  ageGroupTitle,
  ageGroupOrder,
  moderationType,
  judgement,
  premium,
  canMarkAsPremium
}) => {
  return (
    <header className={classes.container}>
      <div className={classes.topHeading}>
        <p className={classes.info}>
          {premium && canMarkAsPremium && <SubsCrown accent />} You are viewing
          a moderation file
        </p>
        <ContextMenu id={id} className="metrics__moderation-af-context" />
      </div>
      <div className={classes.heading}>
        <h1 className={classes.title} id="metrics__moderation-af-title">
          {title}
        </h1>
      </div>
      <AgeGroup order={ageGroupOrder}>{ageGroupTitle}</AgeGroup>
      <p className={classes.context}>{context}</p>
      <ul className={classes.details}>
        {example && (
          <li>
            <strong>Exemplification material</strong>
          </li>
        )}
        {trainingMaterial && (
          <li>
            <strong>Training material</strong>
          </li>
        )}
        {benchmarked && (
          <li>
            <Tooltip content={'Added by ' + benchmarkedBy}>
              <strong>School exemplar</strong>
            </Tooltip>
          </li>
        )}
        <li>
          Created {createAt} ago by {createdBy}
        </li>
        <li>
          {contributions} contribution{contributions > 1 ? 's' : ''}
        </li>
        <li>{concluded ? 1 : 0} conclusion</li>
        {moderationType && (
          <li className={classes.uppercased} uppercased>
            {moderationType}
          </li>
        )}
        {judgement && (
          <li className={classes.uppercased} uppercased>
            {judgement}
          </li>
        )}
      </ul>
      {concluded && conclusionContent && (
        <p className={classes.conclusion}>
          <strong>Conclusion:</strong> <em>{conclusionContent}</em> – 
          {conclusionAuthor}
        </p>
      )}
    </header>
  )
}

export default injectSheet(styles)(Intro)
